/* eslint-disable no-use-before-define */
import React, { createRef, useEffect, useState, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import Modal from '@tds/community-modal';
import { isArray, get, isEqual, every, isObjectLike, isEmpty, debounce } from 'lodash';
import Heading from '@tds/core-heading';
import request, { apiHost } from '../utils/request';
import FormField from './formField';
import ValidateLoader from '../UI/validateLoader';
import ProgressBar from '../design/progressBar';
import UserDetailsForm from './userDetailsForm';
import Note from '../note';
import RepeatedForm from './repeatedForm';
import { msgDisplay, getFieldValue } from './utils';
import { getFormData, isRelatedFieldExisted } from './fomStepFMUtils';
import { findField } from './formStepUtils';
import { useTranslationsContext } from '../context/TranslationsContext';
import { Box } from '../design/css';
import { useLocaleContext } from '../context/LocaleContext';
import { GroupTitle, GroupWrapper } from './css';
import EN from '../../EN.json';
import FR from '../../FR.json';
import {
  typeCheckbox,
  maxUploadSizeValueWLS,
  maxUploadSizeErrorMessageWLS,
  inputTypeFile,
  keyFileSizeExceeded,
  roleLabels,
  localeFrench,
  stepKeyMain,
  fieldActivationLanguage,
  fieldRemediationPaymentPlanTerm,
  fieldRemediationOneTimeCharge,
  fieldRemediationMonthlyCharge,
  fieldRemediationProjectValue,
  fieldRemediationProject,
  fieldFullyManagedTerm,
  categoryFullyManaged,
  fullyManagedForm,
  fullyManagedLandingPage,
  creditCheckNumberField,
  fieldTechnicalReviewNumber
} from '../utils/constant';
import { localeFr, getPathVariables } from '../misc';
import { scrollToErrors } from '../utils/utils';
import FmStatusBar from '../design/fmStatusBar';
import FmSaleSupportStatusBar from '../design/fmStatusBar/saleSupport';

import SelectionsGrid from './fmComponents/selectionGrid/selectionsGrid';
import {
  schema,
  additionalServicesSchema,
  transformAPIDataToForm
} from './fmUtils/managedItServicesSchema';
import FmProductTotal from './fmComponents/fmProductTotal/fmProductTotal';
import {
  getManagedITServicesSummaryPayload,
  getManagedITServicesErrors,
  getDiscountError,
  getDiscountWarnings,
  getDiscountPopupError
} from './fmUtils/utils';
import FmMicrosoftLicensing from './fmComponents/fmMicrosoftLicensing/fmMicrosoftLicensing';
import OrderSummary from './orderSummary/fmOrderSummary';
import DiscountApprovalForm from './fmComponents/discountapprovalform/discountApprovalForm';
import DiscountApprovalSection from './fmComponents/discountApprovalSection/discountApprovalSection'

const formFieldsGroup = 'formFieldsGroup';
const formSection = 'formSection';
const userDetailsKey = 'userDetails';
const repeatedFormKey = 'repeatedForm';
const typeMultiCheckbox = 'MultiCheckbox';
const formSectionTitle = 'formSectionTitle';
const profile = request.getProfile();

const FormStepFM = ({
  stepData,
  steps,
  step,
  setFormRef,
  onFormSubmit,
  orderData,
  hideProgressBar,
  isEditing,
  formName,
  onSaveAndExit,
  updateStep,
  history,
  setOrderData
}) => {
  if (!stepData) return null;
  const managedItServicesErrorRef = useRef(null);
  const discountErrorRef = useRef(null);
  const translations = useTranslationsContext();
  const locale = useLocaleContext();
  const {
    srtDashboardFM: {
      emailDoenotMatch,
      oneTimeTermRemediation,
      _12MonthTermRemediation,
      _24MonthTermRemediation,
      _36MonthTermRemediation,
      _12MonthTermFM,
      _24MonthTermFM,
      _36MonthTermFM,
      emptyOrZeroErrorMessage,
      _36MonthTermErrorMessage,
      _no
    }
  } = locale === 'en-US' ? EN : FR;
  const formRef = useRef(null);

  const {
    contentfulValues: { valueEnglish, valueFrench },
    summaryForm: { summaryLabel },
    formStep: {
      minValueErrorMessage,
      maxValueErrorMessage,
      minLengthErrorMessage,
      maxLengthErrorMessage
    },
    modalForm: { fieldRequiredMessage }
  } = translations;

  const {
    fields: {
      name: formStepName,
      backendKey: formStepBackendKey,
      formStepFields,
      modalForms
    }
  } = stepData;

  const formStepRef = createRef();

  const [localSchema,setLocalSchema] = useState([]);
  const [loading,setLoading] = useState([true]);
  const [isLoading, setIsLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [isFormSubmit, setIsFormSubmit] = useState(false);
  const [formFields, setFormFields] = useState({});
  const [sections, setSections] = useState([]);
  const [showDownloadQuoteFooter, setShowDownloadQuoteFooter] = useState(false);

  // Managed services states
  const [managedItServicesData, setManagedItServicesData] = useState({});
  const [updatedItData,setUpdatedItData] = useState({});
  const [managedItServicesErrors, setManagedItServicesErrors] = useState({});
  const [
    managedItServicesProductTotal,
    setManagedItServicesProductTotal
  ] = useState([0, 0]);
  const [microsoftLicensingData, setMicrosoftLicensingData] = useState({});
  const [additionalServicesData, setAdditionalServicesData] = useState({});
  const [
    additionalServicesProductTotal,
    setAdditionalServicesProductTotal
  ] = useState([0, 0]);
  const [itServicesCategoryTotals, setItServicesCategoryTotals] = useState({});
  const [discountsData, setDiscountsData] = useState([]);
  const [appliedDiscountId, setAppliedDiscountId] = useState('');
  const [discountError, setDiscountError] = useState('');
  const [discountErrorPopupText, setDiscountErrorPopupText] = useState('');

  const getAppliedDiscountItem = useMemo(()=>{
    return discountsData.find(discount => discount.id === appliedDiscountId) || {};

  }, [discountsData, appliedDiscountId, orderData]);

  const resetMicrosoftLicensing = () => {
    setMicrosoftLicensingData({});
    if(orderData.microsoftLicensingData){
    setOrderData({ ...orderData, microsoftLicensingData: {} });
    }
  };
  const resetManagedItServices = () => {
    setManagedItServicesData({});
    setItServicesCategoryTotals({});
    setManagedItServicesProductTotal([0, 0]);
    setOrderData({
      ...orderData,
      managedItServicesSummary: {},
      managedItServicesData: {},
      formattedManagedItServicesData:{}
    });
  };
  const resetAdditionalServices = () => {
    setAdditionalServicesData({});
    setAdditionalServicesProductTotal([0, 0]);
    setOrderData({
      ...orderData,
      additionalServicesSummary: {},
      additionalServicesData: {}
    });
  };

  const sortByIdxRecursively = (data) => {
    if (Array.isArray(data)) {
      // Sort the array by the 'ord' key if present
      data.sort((a, b) => (a.ord !== undefined ? a.ord : Infinity) - (b.ord !== undefined ? b.ord : Infinity));
      // Recursively process each element of the array
      data.forEach(sortByIdxRecursively);
    } else if (data && typeof data === 'object') {
      // If it's an object, process each key
      Object.values(data).forEach(sortByIdxRecursively);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await request.get('/productCatalog');
        
        if (response && response.data && response.data[0] && response.data[0].productCatalogOfferings && response.data[0].productCatalogOfferings[0]) {
          const productCatalog = response.data[0].productCatalogOfferings[0];
          sortByIdxRecursively(productCatalog);
          // Perform transformation
          let transformedData = transformAPIDataToForm(productCatalog);

          // UnComment the below commented code to filterout categories which do not have a service and services which do not have at least one question

           // Filter out categories without services
        transformedData = transformedData
        .map(category => {
          const filteredServices = category.sections.filter(service => service.items && service.items.length > 0);

          // Only keep categories that have at least one valid service
          return filteredServices.length > 0 ? { ...category, sections: filteredServices } : null;
        })
        .filter(category => category !== null);
          
          setLocalSchema(transformedData); // Set transformed data to localSchema
        }
      } catch (error) {
        console.error("Error fetching product catalog:", error);
      } finally {
        setLoading(false); // Set loading to false once data fetching is complete
      }
    };
  
    fetchData();
  }, []);
  
  useEffect(() => {
    setManagedItServicesData(get(orderData, 'managedItServicesData', {}));
    setUpdatedItData(get(orderData, 'formattedManagedItServicesData', {})); 
  }, [orderData]);

  useEffect(() => {
    const newAdditionalServicesData = get(
      orderData,
      'managedItServicesData',
      {}
    );
    const newData = {
      ...newAdditionalServicesData,
      categoryCustomSelections: {
        additionalServices: newAdditionalServicesData.categoryCustomSelections
          ? newAdditionalServicesData.categoryCustomSelections
              .additionalServices
          : {}
      },
      categoryNumberSelections: {
        additionalServices: newAdditionalServicesData.categoryNumberSelections
          ? newAdditionalServicesData.categoryNumberSelections
              .additionalServices
          : {}
      },
      categoryPriceSelections: {
        additionalServices: newAdditionalServicesData.categoryPriceSelections
          ? newAdditionalServicesData.categoryPriceSelections.additionalServices
          : {}
      },
      categorySelections: {
        additionalServices: newAdditionalServicesData.categorySelections
          ? newAdditionalServicesData.categorySelections.additionalServices
          : {}
      },
      categoryTotals: {
        additionalServices: newAdditionalServicesData.categoryTotals
          ? newAdditionalServicesData.categoryTotals.additionalServices
          : {}
      },
      fees: {},
      sectionTotals: {
        additionalServices: newAdditionalServicesData.sectionTotals
          ? newAdditionalServicesData.sectionTotals.additionalServices
          : {}
      }
    };

    setAdditionalServicesData(newData);
  }, [orderData]);

  // useEffect(() => {
  //   setManagedItServicesErrors(
  //     getManagedITServicesErrors(schema, managedItServicesData)
  //   );
  // }, [managedItServicesData, orderData]);

  useEffect(() => {
    const managedItServicesTotal = Object.values(
      itServicesCategoryTotals || {}
    ).reduce(
      (accumulator, currentValue) => {
        accumulator[0] += +currentValue[0];
        accumulator[1] += +currentValue[1];
        return accumulator;
      },
      [0, 0]
    );
    if (
      itServicesCategoryTotals.additionalServices
    ) {
      managedItServicesTotal[0] -= +itServicesCategoryTotals.additionalServices[0];
      managedItServicesTotal[1] -= +itServicesCategoryTotals.additionalServices[1];
    }
    // Calculate product total for managed services
    if (managedItServicesData.categoryTotals) {
      setManagedItServicesProductTotal(managedItServicesTotal);
    }
    const hasManagedItServicesDataChanged = !isEqual(
      orderData.managedItServicesData,
      managedItServicesData
    );
    if (hasManagedItServicesDataChanged) {
      setIsFormTouched(true);
    }
  }, [managedItServicesData]);

  useEffect(() => {
    const additionalServicesTotal = Object.values(
      additionalServicesData.categoryTotals || {}
    ).reduce(
      (accumulator, currentValue) => {
        if (currentValue) {
          accumulator[0] += +currentValue[0];
          accumulator[1] += +currentValue[1];
        }
        return accumulator;
      },
      [0, 0]
    );
    // Calculate product total for managed services
    if (additionalServicesData.categoryTotals) {
      setAdditionalServicesProductTotal(additionalServicesTotal);
    }
    const hasAdditionalServicesDataChanged = !isEqual(
      orderData.additionalServicesData,
      additionalServicesData
    );
    if (hasAdditionalServicesDataChanged) {
      setIsFormTouched(true);
    }
  }, [additionalServicesData]);

  useEffect(() => {
    pickAndApplyDiscountFromOrderData();
  }, [orderData]);

  const pickAndApplyDiscountFromOrderData = () => {
    if(orderData && orderData.appliedDiscountId && !appliedDiscountId){
      setAppliedDiscountId(orderData.appliedDiscountId)
    }
  };

  useEffect(() => {
    if(orderData && discountsData) {
      if(getAppliedDiscountItem.status === 'Rejected') {
        setAppliedDiscountId('');
      }
    }
    
    if(!validateDiscountValidityForOrderValues()){
      setAppliedDiscountId('');
    }
  }, [orderData, discountsData]);

  useEffect(() => {
    const debouncedValidation = debounce(() => {
      if (appliedDiscountId && !validateDiscountValidityForOrderValues()) {
          setAppliedDiscountId('');
      }
  }, 300);
  debouncedValidation();

  return () => debouncedValidation.cancel();
  }, [itServicesCategoryTotals]);

  const { role } = (typeof profile !== 'undefined' && profile) || {};

  let hasProductManagedITServices;

  let hasProductMicrosoftLicensing;

  const validateDiscountValidityForOrderValues = () => {
    // If the Managed IT Services / Onboarding Fee do not match, unapply it.
    if(appliedDiscountId && discountsData.length) {
      const orderManagedITServices = getManagedItServicesTotal('monthly');
      const orderOnboardingFee = getManagedItServicesTotal('oneTime');
      if(
        (+(orderManagedITServices || 0).toFixed(2) !== +(getAppliedDiscountItem.requestedForManagedITServicesValue || 0).toFixed(2)) ||
        (+(orderOnboardingFee || 0).toFixed(2) !== +(getAppliedDiscountItem.requestedForOnboardingFeeValue || 0).toFixed(2))
      ){
        return false;
      }
    }
    return true;
  };

  const getManagedItServicesTotal = type => {
    if (step === 1) {
      if (hasProductManagedITServices) {
        if (type === 'monthly') {
          return managedItServicesProductTotal[1];
        }
        if (managedItServicesData.fees) {
          return (
            (managedItServicesData.fees.onboardingFee || 0) +
            (managedItServicesData.fees.additionalOneTimeFee || 0)
          );
        }
      }
    } else if (orderData && Object.keys(orderData).length > 0) {
      if (
        orderData.productSelectionFM &&
        orderData.productSelectionFM.includes('Managed IT Services')
      ) {
        if (type === 'monthly') {
          return orderData.managedItServicesSummary.totalMonthlyCharges - getAdditionalServicesTotal('monthly');
        }
        return orderData.managedItServicesSummary.totalOneTimeCharges;
      }
    }

    return 0;
  };

  const getAdditionalServicesTotal = type => {
    if (step === 1) {
      if (hasProductManagedITServices) {
        if (type === 'monthly') {
          return additionalServicesProductTotal[1];
        }
      }
    }
    return get(orderData, 'managedItServicesData.sectionTotals.additionalServices.additionalServices', [0, 0])[1];
  };

  const getMicrosoftLicensingTotal = () => {
    if (step === 1) {
      if (hasProductMicrosoftLicensing && microsoftLicensingData) {
        return microsoftLicensingData.adjustedTotalPrice;
      }
    } else if (orderData && Object.keys(orderData).length > 0) {
      if (
        orderData.productSelectionFM &&
        orderData.productSelectionFM.includes('Microsoft Licensing')
      ) {
        return (
          orderData.microsoftLicensingData &&
          orderData.microsoftLicensingData.adjustedTotalPrice
        );
      }
    }

    return 0;
  };

  const onChangeItServicesFees = data => {
    setManagedItServicesData({ ...managedItServicesData, fees: data });
  };

  // const onChangeAdditionalServicesFees = data => {
  //   setAdditionalServicesData({ ...additionalServicesData, fees: data });
  // };

  const getAddedDiscounts = async(orderId, discountId) => {
    if(discountId) {
      setAppliedDiscountId(discountId);
      saveAndExit(false);
    }
    try {
      const discounts = await request.get(`/discounts/?orderId=${orderId}`);
      if(discounts && discounts.data && discounts.data.length){
        setDiscountsData(discounts.data);
      } else {
        setDiscountsData([]);
      }
    } catch(e) {
      console.log(e);
    }
  }

  const onApplyDiscount = (id, action) => {
    if(action === 'apply'){
      setAppliedDiscountId(id);
    } else if(action === 'unApply') {
      setAppliedDiscountId('');
    }
    setShowDownloadQuoteFooter(false);

  }

  const onChangeItServicesData = ({
    category,
    categoryTotal,
    sectionTotals,
    selections,
    customSelections,
    numberFields,
    priceSelections
  }) => {
    setManagedItServicesData(prevManagedItServicesData => ({
      ...prevManagedItServicesData,
      categoryTotals: {
        ...prevManagedItServicesData.categoryTotals,
        [category]: categoryTotal
      },
      sectionTotals: {
        ...prevManagedItServicesData.sectionTotals,
        [category]: sectionTotals
      },
      categorySelections: {
        ...prevManagedItServicesData.categorySelections,
        [category]: selections
      },
      categoryCustomSelections: {
        ...prevManagedItServicesData.categoryCustomSelections,
        [category]: customSelections
      },
      categoryNumberSelections: {
        ...prevManagedItServicesData.categoryNumberSelections,
        [category]: numberFields
      },
      categoryPriceSelections: {
        ...prevManagedItServicesData.categoryPriceSelections,
        [category]: priceSelections
      }
    }));
  };

  // function to format data compatible with BE logics
  const formatManagedItServicesData = ({
    category,
   localData,
   idx,
   categoryId
  }) => {
    setUpdatedItData(prevManagedItServicesData => ({
        ...prevManagedItServicesData,
        [category]: {
            idx,
            categoryId,
          ...prevManagedItServicesData[category],
          ...localData
        },
       
      }));
  };

  const onChangeCategoryTotals = categoryTotal => {
    setItServicesCategoryTotals(prevManagedItServicesData => ({
      ...prevManagedItServicesData,
      ...categoryTotal
    }));
  };

  const onChangeAdditionalServicesData = ({
    category,
    categoryTotal,
    sectionTotals,
    selections,
    customSelections,
    numberFields,
    priceSelections
  }) => {
    setAdditionalServicesData(prevAdditionalServicesData => ({
      ...prevAdditionalServicesData,
      categoryTotals: {
        ...prevAdditionalServicesData.categoryTotals,
        [category]: categoryTotal
      },
      sectionTotals: {
        ...prevAdditionalServicesData.sectionTotals,
        [category]: sectionTotals
      },
      categorySelections: {
        ...prevAdditionalServicesData.categorySelections,
        [category]: selections
      },
      categoryCustomSelections: {
        ...prevAdditionalServicesData.categoryCustomSelections,
        [category]: customSelections
      },
      categoryNumberSelections: {
        ...prevAdditionalServicesData.categoryNumberSelections,
        [category]: numberFields
      },
      categoryPriceSelections: {
        ...prevAdditionalServicesData.categoryPriceSelections,
        [category]: priceSelections
      }
    }));
  };

  const onChangeMicrosoftLicensingData = data => {
    setMicrosoftLicensingData(data);
  };

  const getDefaultValue = (key, value) => {
    if (isEditing && orderData) return orderData[key];
    return value || '';
  };
  
  function syncData(mainData, newObject) {
    const updatedCategories = {};
    // isPremiumSelect determines if premium pricing is to be used or regular pricing
    const isPremiumSelected = get(newObject,["Customer Success (Relationship)","Customer Success (Relationship)","Choose the relationship level","value"]);
    mainData.forEach(category => {
      const {categoryId} = category; // Use categoryId for identification
      const existingCategoryKey = Object.keys(newObject).find(
        key => newObject[key].categoryId === categoryId
      );
  
      // Handle category renaming
      if (existingCategoryKey && existingCategoryKey !== category.categoryName.trim()) {
        updatedCategories[category.categoryName.trim()] = newObject[existingCategoryKey];
        delete newObject[existingCategoryKey];
      } else if (!existingCategoryKey) {
        updatedCategories[category.categoryName.trim()] = {};
      } else {
        updatedCategories[category.categoryName.trim()] = newObject[existingCategoryKey];
      }
      const categoryData = updatedCategories[category.categoryName.trim()];
      categoryData.categoryId = categoryId;
  
      // Sync sections within the category by sectionId
      category.sections.forEach((section, index) => {
        const sectionId = section.id; // Use sectionId for identification
        const existingSectionKey = Object.keys(categoryData).find(
          key => categoryData[key].sectionId === sectionId
        );
  
        // Handle section renaming
        if (existingSectionKey && existingSectionKey !== section.title.trim()) {
          categoryData[section.title.trim()] = categoryData[existingSectionKey];
          delete categoryData[existingSectionKey];
        } else if (!existingSectionKey) {
          categoryData[section.title.trim()] = {};
        }
  
        const sectionData = categoryData[section.title.trim()];
        sectionData.sectionId = sectionId;
        sectionData.numberField = section.numberField ? sectionData.numberField : "";
        sectionData.numberLabel = section.numberField && section.numberField.label || "";
        sectionData.sectionTotals = section.sectionTotals || [0, 0];
        
        // Sync items within the section by itemId
        section.items.forEach(item => {
          const itemId = item.id; // Use itemId for identification
          const existingItemKey = Object.keys(sectionData).find(
            key => {
                  if(!["numberField","sectionIndex","numberLabel","sectionId"].includes(key))
                      return sectionData[key].itemId === itemId;
                  else 
                      return;
            }
          );
  
          // Handle item label renaming
          if (existingItemKey && existingItemKey !== item.label.trim()) {
            sectionData[item.label.trim()] = sectionData[existingItemKey];
            delete sectionData[existingItemKey];
          } else if (!existingItemKey) {
            sectionData[item.label.trim()] = {};
          }
  
          const itemData = sectionData[item.label.trim()];
          itemData.itemId = itemId;
          
          // Sync price selection for the item based on the options
          item.options.forEach(option => {
            if (itemData.optionId === option.optionId) {
              itemData.value = option.label || ""; // Retain or set value if empty
              const key = isPremiumSelected && typeof isPremiumSelected === 'string' && isPremiumSelected.trim() === "Premium / Legal"
                ? "premiumAdditionalData"
                : "additionalData";
              itemData.priceSelection = {
                cost: option[key].cost,
                price: option[key].price,
              };
            }
          });
  
          // If the item has no matching optionId, remove invalid priceSelection
          if (!itemData.optionId) {
            delete itemData.priceSelection;
          }
        });
  
        // Remove items from sectionData that no longer exist in the mainData
        Object.keys(sectionData).forEach(itemLabel => {
          if (
            itemLabel !== "sectionId" &&
            itemLabel !== "numberField" &&
            itemLabel !== "numberLabel" &&
            itemLabel !== "sectionTotals" &&
            itemLabel !== "sectionIndex"
          ) {
              const existsInMain = section.items.find(item => item.label === itemLabel);

            if (!existsInMain) {
              delete sectionData[itemLabel];
            }
          }
        });
      });
  
      // Remove sections from categoryData that no longer exist in mainData
      Object.keys(categoryData).forEach(sectionName => {
        if (!["categoryId","idx","categoryTotals"].includes(sectionName) ) {
          const existsInMain = category.sections.find(sec => sec.title === sectionName);
          if (!existsInMain) {
            delete categoryData[sectionName];
          }
        }
      });
    });
  
    // Remove categories from newObject that no longer exist in mainData
    Object.keys(newObject).forEach(categoryName => {
      const existsInMain = mainData.find(cat => cat.categoryName === categoryName);
      if (!existsInMain) {
        delete newObject[categoryName];
      }
    });
  
    // Replace newObject with updated categories
    Object.assign(newObject, updatedCategories);
  
    return newObject;
  }

  useEffect(()=>
    {
        const syncedData = syncData(localSchema,updatedItData);
        setUpdatedItData(syncedData);
    },[localSchema,orderData]);
      
  const open = sections.reduce((acc, section) => {
    const {
      fields: { name, isPanelInitiallyOpen, formFields: sectionFields }
    } = section;

    if (isPanelInitiallyOpen) {
      acc.push(name);
    } else {
      const isErrors =
        sectionFields &&
        sectionFields.find(item => {
          const {
            fields: { name: itemName }
          } = item;
          return formErrors[itemName];
        });
      if (typeof isErrors !== 'undefined') acc.push(name);
    }

    return acc;
  }, []);

  const normalizedFields = (data, initFields) => {
    let result = initFields;
    if (data) {
      data.forEach(item => {
        const { sys, fields } = item;
        const {
          name,
          type,
          required,
          value,
          minValue,
          maxValue,
          minLength,
          maxLength,
          price,
          monthlyPayment,
          options,
          tooltip,
          noteAppearsBelowField,
          customFieldErrorMessage
        } = fields;
        const {
          contentType: {
            sys: { id }
          }
        } = sys;
        const key = name;
        const ref = createRef();

        if (id === formFieldsGroup) {
          result = normalizedFields(fields.fields, result);
        } else if (id === formSection) {
          result = normalizedFields(fields.formFields, result);
        } else if (id === userDetailsKey) {
          result = normalizedFields(fields.formStepFields, result);
        } else if (id === repeatedFormKey) {
          const formObjectKeys = fields.formFields.reduce(
            (acc, { fields: { name: formNameKey, value: defaultValue } }) => {
              acc[formNameKey] = defaultValue;
              return acc;
            },
            {}
          );
          result[fields.key] = [formObjectKeys];
        } else if (!Object.prototype.hasOwnProperty.call(result, key)) {
          let defaultValue = getDefaultValue(key, value);
          let updatedMonthlyPayment = monthlyPayment;
          let updatedPrice = price;

          if (['Select', 'Radio'].includes(type)) {
            if (options && defaultValue) {
              const currentOption = options.find(
                o => o.fields.value === defaultValue
              );

              if (typeof currentOption !== 'undefined') {
                updatedPrice = currentOption.fields.price;
                updatedMonthlyPayment = currentOption.fields.monthlyPayment;
              }
            }
          }

          if (type === typeMultiCheckbox) {
            if (defaultValue && defaultValue.length > 0 && options) {
              const updateDefaultValue =
                typeof defaultValue === 'string'
                  ? defaultValue.split(',')
                  : defaultValue;
              const mappedValues = updateDefaultValue.reduce(
                (ac, a) => ({ ...ac, [a]: true }),
                {}
              );
              updatedPrice = options.reduce(
                (ac, a) =>
                  ac + ((mappedValues[a.fields.value] && a.fields.price) || 0),
                0
              );
              updatedMonthlyPayment = options.reduce(
                (ac, a) =>
                  ac +
                  ((mappedValues[a.fields.value] && a.fields.monthlyPayment) ||
                    0),
                0
              );
            }
          }

          /**
           * Condition to select default activation lagnguage
           * based on the curren locale
           */
          if (key === fieldActivationLanguage) {
            const currentLocale = getPathVariables(window.location.pathname)[0];
            defaultValue =
              currentLocale === localeFr ? valueFrench : valueEnglish;
          }

          result[key] = {
            name,
            ref,
            type,
            value: defaultValue || value,
            initPrice: updatedPrice || 0,
            price: updatedPrice || 0,
            initMonthlyPayment: updatedMonthlyPayment || 0,
            monthlyPayment: updatedMonthlyPayment || 0,
            minValue,
            maxValue,
            minLength,
            maxLength,
            isRequired: required || false,
            isVisible: true,
            options,
            tooltip,
            noteAppearsBelowField,
            customFieldErrorMessage
          };

          if (type === 'Checkbox') {
            result[key].checked = defaultValue;
          }

          if (
            type === 'PlusMinusInput' &&
            defaultValue === undefined &&
            value
          ) {
            result[key].value = value;
          }
        }
      });
    }

    return result;
  };

  const formSections = formStepFields.filter(({ sys }) => {
    const {
      contentType: {
        sys: { id }
      }
    } = sys;

    return id === formSection;
  });

  const getHiddenSections = fields => {
    const hiddenSections = [];

    formSections.forEach(section => {
      const {
        fields: { name: sectionName }
      } = section;
      if (
        !isRelatedFieldExisted(section.fields, fields, orderData, isFormTouched)
      ) {
        hiddenSections.push(sectionName);
      }
    });

    return hiddenSections;
  };

  const updateSections = updatedSections => {
    let newSections = [...formSections];
    updatedSections.forEach(item => {
      newSections = newSections.filter(section => section.fields.name !== item);
    });
    setSections(newSections);
  };

  useEffect(() => {
    if (
      (!isEditing && formStepFields) ||
      (isEditing && orderData && orderData.id)
    ) {
      const updatedFields = normalizedFields(formStepFields, formFields);
      setFormFields(updatedFields);
      updateSections(getHiddenSections(updatedFields));
      setIsLoading(false);
      setIsFormTouched(false);
      if (formStepRef && formStepRef.current)
        formStepRef.current.scrollTo(0, 0);
    }
  }, [formStepFields, orderData, locale]);

  const sectionIsVisible = name =>
    typeof sections.find(item => item.fields.name === name) !== 'undefined';

  const getRepeatedFormErrors = (contentfulFields, formValues) => {
    const fields = contentfulFields.filter(
      ({ fields: content }) => content.required || content.fieldValidation
    );
    return formValues.filter(formValue => {
      let filteredValues = fields.filter(
        ({ fields: { name: formKeyValue } }, index) => {
          return (
            !formValue[formKeyValue] || fields[index].fields.fieldValidation
          );
        }
      );

      const removeValidationErrors =
        filteredValues &&
        filteredValues.filter(item => {
          if (item.fields.fieldValidation) {
            if (
              item.fields.fieldValidation.fields.logic &&
              item.fields.fieldValidation.fields.logic === 'regex'
            ) {
              // Add regex logic
            }
          }
          return null;
        });
      filteredValues = removeValidationErrors;
      return filteredValues.length > 0;
    });
  };

  const getAccumulatedFilesSize = files => {
    const keys = Object.keys(files);
    let size = 0;
    // eslint-disable-next-line no-unused-expressions
    keys.length > 0 &&
      keys.forEach(key => {
        if (files[key]) {
          const [file] = Object.keys(files[key]);
          if (files[key][file] && files[key][file].size) {
            size += files[key][file].size;
          }
        }
      });
    return size;
  };

  const getErrors = (data, errors) => {
    scrollToErrors(errors);
    let result = errors;
    if (!data) return result;
    data.forEach(({ sys, fields }) => {
      const {
        contentType: {
          sys: { id }
        }
      } = sys;
      const { name: key, type, customFieldErrorMessage } = fields;
      const {
        value,
        minValue,
        maxValue,
        isRequired,
        isVisible,
        ref,
        minLength,
        maxLength
      } =
        formFields &&
        Object.prototype.hasOwnProperty.call(formFields, key) &&
        formFields[key];
      const { files } = formFields;

      if (
        id === formFieldsGroup &&
        isRelatedFieldExisted(fields, formFields, orderData, isFormTouched)
      ) {
        result = getErrors(fields.fields, result);
      } else if (id === formSection && sectionIsVisible(key)) {
        result = getErrors(fields.formFields, result);
      } else if (id === userDetailsKey) {
        result = getErrors(fields.formStepFields, result);
      } else if (id === repeatedFormKey) {
        const repeatedFormErrors = getRepeatedFormErrors(
          fields.formFields,
          formFields[fields.key]
        );
        if (repeatedFormErrors.length) {
          result[fields.key] = repeatedFormErrors;
        } else {
          delete result[fields.key];
        }
      } else if (isVisible) {
        if (isRequired) {
          let fieldValue = value;
          if (type === typeMultiCheckbox) {
            const multiCheckboxValue = getFieldValue(key, formFields);
            fieldValue = multiCheckboxValue && multiCheckboxValue.length > 0;
          }
          if (
            !fieldValue &&
            isRelatedFieldExisted(fields, formFields, orderData, isFormTouched)
          ) {
            if (!(type === typeCheckbox && formFields[key].checked)) {
              result[key] = {
                text: customFieldErrorMessage || fieldRequiredMessage,
                ref
              };
            } else {
              delete result[key];
            }
          } else {
            delete result[key];
          }
        }
        if (typeof minValue !== 'undefined' && parseFloat(value) < minValue) {
          result[key] = {
            text: msgDisplay(minValue, minValueErrorMessage),
            ref
          };
        }
        if (typeof maxValue !== 'undefined' && parseFloat(value) > maxValue) {
          result[key] = {
            text: msgDisplay(maxValue, maxValueErrorMessage),
            ref
          };
        }
        if (minLength && value && value.length < minLength) {
          result[key] = {
            text: msgDisplay(minLength, minLengthErrorMessage),
            ref
          };
        }
        if (maxLength && value && value.length > maxLength) {
          result[key] = {
            text: msgDisplay(maxLength, maxLengthErrorMessage),
            ref
          };
        }
        if (type === inputTypeFile && files) {
          if (getAccumulatedFilesSize(files) > maxUploadSizeValueWLS) {
            result[keyFileSizeExceeded] = {
              text: maxUploadSizeErrorMessageWLS,
              ref
            };
          } else {
            delete result[keyFileSizeExceeded];
          }
        }
      // Validations for Remediation Project Value 
        if (key === fieldRemediationProjectValue) {
          const valueFMTerm = getFieldValue(fieldFullyManagedTerm, formFields);
          const valueRemediationTerm = getFieldValue(fieldRemediationPaymentPlanTerm, formFields);
          const valueRemediationCharge = getFieldValue(fieldRemediationProjectValue, formFields);
          const valueRemediationProject = getFieldValue(fieldRemediationProject, formFields)
           
           if (valueFMTerm  === _12MonthTermFM) {
                if (valueRemediationCharge < 1 ) {
                  result[key] = {
                      text: emptyOrZeroErrorMessage,
                      ref
                  };
              } else {
                  delete result[key];
              }
          } else if (valueFMTerm === _24MonthTermFM) {
                if (valueRemediationCharge < 1 ) {
                  result[key] = {
                      text: emptyOrZeroErrorMessage,
                      ref
                  };
              } else {
                  delete result[key];
              }
          } else if (valueFMTerm === _36MonthTermFM) {
                if (valueRemediationCharge < 1 ) {
                  result[key] = {
                      text: emptyOrZeroErrorMessage,
                      ref
                  };
              } else if ([_36MonthTermRemediation].includes(valueRemediationTerm) && valueRemediationCharge < 10000) {
                  result[key] = {
                      text: _36MonthTermErrorMessage,
                      ref
                  };
              } else {
                  delete result[key];
              }
          } else {
                delete result[key];
          }

          if (valueFMTerm && valueRemediationProject === _no) { 
            delete result[key];
          }
        }

        if (fields.fieldValidation && fields.fieldValidation.fields) {
          if (
            typeof fields.appearsAfterField === 'undefined' ||
            (typeof fields.appearsAfterField !== 'undefined' &&
              isRelatedFieldExisted(
                fields,
                formFields,
                orderData,
                isFormTouched
              ))
          ) {
            const {
              errorMessage,
              logic,
              value: expectedValue
            } = fields.fieldValidation.fields;
            let hasError = false;
            switch (logic) {
              case 'equal':
                // eslint-disable-next-line eqeqeq
                hasError = !expectedValue.split('|').includes(value);
                break;
              case 'regex':
                {
                  const regexLogic = new RegExp(expectedValue);
                  hasError = !regexLogic.test(value);
                }
                break;
              case 'gt':
                hasError = parseInt(value, 10) < parseInt(expectedValue, 10);
                break;
              case 'gte':
                hasError = parseInt(value, 10) <= parseInt(expectedValue, 10);
                break;
              case 'lt':
                hasError = parseInt(value, 10) < parseInt(expectedValue, 10);
                break;
              default:
            }
            if (hasError) result[key] = { text: errorMessage, ref };
            if ((!isRequired && !value) || (!isRequired && !hasError))
              delete result[key];
          }
        }
      }
    });
    // Checking if Signing Authority & Re-enter Signing Authority emails are the same
    if (
      getFieldValue('emailAddressFM', formFields) !==
      getFieldValue('reEnterEmailFM', formFields)
    ) {
      result.emailAddressFM = {
        text: emailDoenotMatch,
        ref: formFields.reEnterEmailFM.ref
      };
    }
    return result;
  };

  const saveAndExit = (shouldExit = true) => {
    let productDiscountPayload;
    const syncedData =   syncData(localSchema,updatedItData);
    setUpdatedItData(syncedData);
        
    const managedAndAdditionalServicesData = {
      ...managedItServicesData,
      categoryCustomSelections: {
        ...managedItServicesData.categoryCustomSelections,
        ...additionalServicesData.categoryCustomSelections
      },
      categoryTotals: {
        ...managedItServicesData.categoryTotals,
        ...additionalServicesData.categoryTotals
      },
      sectionTotals: {
        ...managedItServicesData.sectionTotals,
        ...additionalServicesData.sectionTotals
      }
    };
    const managedSummary = getManagedITServicesSummaryPayload(
      managedItServicesData,
      localSchema,
      managedItServicesProductTotal
    );
    const additionalSummary = getManagedITServicesSummaryPayload(
      additionalServicesData,
      additionalServicesSchema,
      additionalServicesProductTotal
    );

    const filteredCharges = managedSummary.charges.filter(charge => {
      return !charge.name.startsWith('Additional Service');
    });
    const managedITServicesPayload = hasProductManagedITServices
      ? {
        formattedManagedItServicesData: {...updatedItData},
          managedItServicesData: managedAndAdditionalServicesData,
          managedItServicesSummary: {
            ...managedSummary,
            additionalCharges: [...managedSummary.additionalCharges],
            charges: [...filteredCharges, ...additionalSummary.charges],
            totalMonthlyCharges:
              managedSummary.totalMonthlyCharges +
              additionalSummary.totalMonthlyCharges,
            totalOneTimeCharges:
              managedSummary.totalOneTimeCharges +
              additionalSummary.totalOneTimeCharges
          }
        }
      : {
          managedItServicesData: undefined,
          managedItServicesSummary: undefined
        };

    const microsoftLicencingPayload = hasProductMicrosoftLicensing
      ? {
          microsoftLicensingData: {
            ...microsoftLicensingData
          }
        }
      : {
          microsoftLicensingData: undefined
        };
    const fields = getFormData(formFields);
    if (Object.entries(fields).length) {
      onSaveAndExit({
        ...fields,
        ...managedITServicesPayload,
        ...microsoftLicencingPayload,
        ...productDiscountPayload,
        appliedDiscountId
      }, shouldExit);
    } // TODO: remove this redundency i.e move to getFormData
  };

  const prevStep = e => {
    e.preventDefault();
    setFormErrors({});
    setIsLoading(true);
    setIsFormSubmit(false);
    updateStep(step - 1);
    history.push({
      pathname: `/${locale}/${categoryFullyManaged}/${fullyManagedForm}`,
      search: `?orderId=${orderData.id}&step=${step - 1}&isEditing=true`
    });
  };

  const nextStepSaleSupport = e => {
    e.preventDefault();
    setFormErrors({});
    setIsLoading(true);
    setIsFormSubmit(false);
    updateStep(step + 1);
    if (step === 3) {
      history.push({
        pathname: `/${locale}/${categoryFullyManaged}/${fullyManagedLandingPage}`
      });
      window.location.reload();
    } else {
      history.push({
        pathname: `/${locale}/${categoryFullyManaged}/${fullyManagedForm}`,
        search: `?orderId=${orderData.id}&step=${step + 1}&isEditing=true`
      });
    }
  };

  const nextStep = async e => {
    e.preventDefault();
    const errors = getErrors(formStepFields, { ...formErrors });

    setFormErrors(errors);
    setManagedItServicesErrors(
      getManagedITServicesErrors(localSchema, managedItServicesData)
    );

    if (
      step === 1 &&
      hasProductManagedITServices &&
      !(
        every(
          getManagedITServicesErrors(localSchema, managedItServicesData),
          isObjectLike
        ) &&
        every(
          getManagedITServicesErrors(localSchema, managedItServicesData),
          isEmpty
        )
      )
    ) {

      managedItServicesErrorRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      return;
    }
    const formDiscountError = getDiscountError(
      appliedDiscountId,
      getFieldValue(fieldFullyManagedTerm, formFields) === _12MonthTermFM,
      getManagedItServicesTotal('monthly') + getAdditionalServicesTotal('monthly'),
      getFieldValue(creditCheckNumberField, formFields) && getFieldValue(fieldTechnicalReviewNumber, formFields)
    );
    if(step === 1 && appliedDiscountId) {
      const formDicountErrorPopupError = getDiscountPopupError(
        discountsData.find(discount => discount.id === appliedDiscountId)
      );
      setDiscountErrorPopupText(formDicountErrorPopupError);
      if(formDicountErrorPopupError) return;
    } 
    if(formDiscountError && appliedDiscountId) {
      setDiscountError(formDiscountError);
      discountErrorRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      return;
    }
    setDiscountError('')

    if (Object.entries(errors).length === 0) {
    const syncedData =   syncData(localSchema,updatedItData);
    setUpdatedItData(syncedData);
      const shouldShowDownloadQuote =
        formName !== fullyManagedLandingPage &&
        !showDownloadQuoteFooter &&
        step === 1;
      setShowDownloadQuoteFooter(shouldShowDownloadQuote);
      const fields = getFormData(formFields);
      let managedITServicesPayload = {
        managedItServicesData: undefined,
        managedItServicesSummary: undefined,
        formattedManagedItServicesData: undefined
      };
      let productDiscountPayload;
      let microsoftLicencingPayload = { microsoftLicensingData: undefined };
      if (hasProductManagedITServices) {
        const managedAndAdditionalServicesData = {
          ...managedItServicesData,
          categoryCustomSelections: {
            ...managedItServicesData.categoryCustomSelections,
            ...additionalServicesData.categoryCustomSelections
          },
          categoryTotals: {
            ...managedItServicesData.categoryTotals,
            ...additionalServicesData.categoryTotals
          },
          sectionTotals: {
            ...managedItServicesData.sectionTotals,
            ...additionalServicesData.sectionTotals
          }
        };

        const managedSummary = getManagedITServicesSummaryPayload(
          managedItServicesData,
          localSchema,
          managedItServicesProductTotal
        );
        const additionalSummary = getManagedITServicesSummaryPayload(
          additionalServicesData,
          additionalServicesSchema,
          additionalServicesProductTotal
        );

        const filteredCharges = managedSummary.charges.filter(charge => {
          return !charge.name.startsWith('Additional Service');
        });
        managedITServicesPayload = {
            formattedManagedItServicesData: {...updatedItData},
          managedItServicesData: managedAndAdditionalServicesData,
          managedItServicesSummary: {
            ...managedSummary,
            additionalCharges: [...managedSummary.additionalCharges],
            charges: [...filteredCharges, ...additionalSummary.charges],
            totalMonthlyCharges:
              managedSummary.totalMonthlyCharges +
              additionalSummary.totalMonthlyCharges,
            totalOneTimeCharges:
              managedSummary.totalOneTimeCharges +
              additionalSummary.totalOneTimeCharges
          }
        };
      } else {
        resetManagedItServices();
        resetAdditionalServices();
      }
      if (hasProductMicrosoftLicensing) {
        microsoftLicencingPayload = {
          microsoftLicensingData: {
            ...microsoftLicensingData
          }
        };
      } else {
        resetMicrosoftLicensing();
      }
      onFormSubmit(
        {
          ...(step === 1
            ? {
                ...managedITServicesPayload,
                ...microsoftLicencingPayload,
                ...productDiscountPayload,
                discountValue: appliedDiscountId ? getAppliedDiscountItem.approvedMonthly : undefined,
                oneTimeDiscountValue: appliedDiscountId ? getAppliedDiscountItem.approvedOnetime : undefined,
                overrideMonthlyDiscountValue: appliedDiscountId ? getAppliedDiscountItem.overrideMonthly || "" : undefined,
                overrideOnetimeDiscountValue: appliedDiscountId ? getAppliedDiscountItem.overrideOnetime || "" : undefined,
                appliedDiscountId
              }
            : {}),
          ...fields
        }, // TODO: remove this redundency i.e move to getFormData
        !shouldShowDownloadQuote,
        step === steps.length
      );
    } else {
      const firstError = errors[Object.keys(errors)[0]];
      const { ref } = firstError;
      if (ref && ref.current) ref.current.focus();
    }
  };

  const onSaveAndCloseDiscountPopup = (shouldNavigateToDashboard = false) => {
    setDiscountErrorPopupText('');
    saveAndExit(shouldNavigateToDashboard);
  };

  useEffect(() => {
    if(orderData.id) {
      getAddedDiscounts(orderData.id);
    }
  }, [orderData]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  const handleKeyDown = e => {
    if (role.name === 'SALES_SUPPORT' && e.key === 'Tab') {
      e.preventDefault();
    }
  };

  const resetFormFields = fields => {
    const updatedFields = Object.keys(fields).reduce((acc, fieldKey) => {
      const currentFormField = findField(formStepFields, fieldKey);
      // If field type is array, then it'll be ignored with the below logic
      if (isArray(fields[fieldKey])) {
        return { ...acc, [fieldKey]: fields[fieldKey] };
      }
      const isVisible = isRelatedFieldExisted(
        get(currentFormField, 'fields', {}),
        fields,
        orderData,
        true
      );

      if (!isVisible)
        return { ...acc, [fieldKey]: { ...fields[fieldKey], value: '' } };
      return { ...acc, [fieldKey]: { ...fields[fieldKey] } };
    }, {});
    return updatedFields;
  };

  const handleFormField = (
    { name, value, checked, files },
    ref,
    isFieldModified
  ) => {
    const fields = { ...formFields };

    if (isFieldModified && !isFormTouched) {
      setIsFormTouched(true);
      setShowDownloadQuoteFooter(false);
    }
    fields[name] = { ...fields[name], value, checked, isVisible: true };

    if (name === 'productSelectionFM' && value.length === 0) {
      resetManagedItServices();
    }
    if (name === 'productSelectionFM' && value.length === 1) {
      resetMicrosoftLicensing();
    }
    // Form sections visibility can be related to fields and values
    updateSections(getHiddenSections(fields));

    const valueRemediationProjectValue = getFieldValue(fieldRemediationProjectValue, fields);
    const valueRemediationPaymentPlanTerm = getFieldValue(fieldRemediationPaymentPlanTerm, fields);

    if (valueRemediationPaymentPlanTerm === oneTimeTermRemediation) {
      fields.remediationOneTimeCharge.value = valueRemediationProjectValue;
    } else if (valueRemediationPaymentPlanTerm === _12MonthTermRemediation) {
      const monthlyPaymentRemediation = (valueRemediationProjectValue * 1.02) / 12;
      fields.remediationMonthlyCharge.value = monthlyPaymentRemediation.toFixed(2);  
    } else if (valueRemediationPaymentPlanTerm === _24MonthTermRemediation) {
      const monthlyPaymentRemediation = (valueRemediationProjectValue * 1.03) / 24;
      fields.remediationMonthlyCharge.value = monthlyPaymentRemediation.toFixed(2);  
    } else if (valueRemediationPaymentPlanTerm === _36MonthTermRemediation) {
      const monthlyPaymentRemediation = (valueRemediationProjectValue * 1.04) / 36;
      fields.remediationMonthlyCharge.value = monthlyPaymentRemediation.toFixed(2);  
    } 

    if (name === fieldRemediationProject) {
      fields.remediationOneTimeCharge.value = undefined;
      fields.remediationMonthlyCharge.value = undefined;
    }
    if (files && files.length) {
      const [file] = files;
      const checkFileExists = (filesToCheck, fileKey) =>
        filesToCheck.find(fileDetails => fileDetails[fileKey]);
      const updateFile = (fileList, fileKey, updatedFile) => {
        const updatedFileList = fileList.map(fileDetails => {
          if (fileDetails[fileKey]) {
            // eslint-disable-next-line no-param-reassign
            fileDetails[name] = updatedFile;
          }
          return fileDetails;
        });
        return updatedFileList;
      };
      if (
        fields.files &&
        fields.files.length &&
        !checkFileExists(fields.files, name)
      ) {
        fields.files.push({ [name]: file });
      } else if (
        fields.files &&
        fields.files.length &&
        checkFileExists(fields.files, name)
      ) {
        const updatedFileList = updateFile(fields.files, name, file);
        fields.files = updatedFileList;
      } else {
        fields.files = [{ [name]: file }];
      }
      fields[name].value = file.name;
    }
    setFormFields(resetFormFields(fields));
  };

  const renderFormFields = data =>
    data &&
    data.length > 0 &&
    data.map(({ sys, fields }, indexRoot) => {
      const {
        contentType: {
          sys: { id }
        },
        id: sysId
      } = sys;
      //   const disableOptions = (options, targets, value) => {
      //     const updatedOptions = [...options];
      //     targets.forEach(target => {
      //       updatedOptions.forEach(option => {
      //         if (option.fields.value === target) {
      //           // eslint-disable-next-line no-param-reassign
      //           option.fields.disabledOption = value;
      //         }
      //       });
      //     });
      //     return updatedOptions;
      //   };
      const { name: fieldName, title, expiredDate } = fields;
      let selectOptions;
      const error = formErrors[fieldName];

      const key = `FormField${fieldName}${indexRoot}${sysId}`;
      let result;
      let fieldNote;

      if (expiredDate && new Date(expiredDate) < new Date()) return null;
      if (!isRelatedFieldExisted(fields, formFields, orderData, isFormTouched))
        return null;

      const fieldValue = getFieldValue(fieldName, formFields);
      // if (fieldName === fieldFullyManagedTerm) {
      //   formFields[fieldName].value = _12MonthTermFM;
      // }

      if(fieldName === fieldFullyManagedTerm){
        const valueFMTerm = getFieldValue(fieldFullyManagedTerm, formFields);
        if(appliedDiscountId){
          const appliedDiscountItem = discountsData.find(discount => discount.id === appliedDiscountId);
          if(appliedDiscountItem && valueFMTerm !== appliedDiscountItem.term){
            setAppliedDiscountId(null);
          }
        }
      }

      if (
        fieldName === 'purchaseOrder' &&
        formFields[fieldName].value !== 'Yes'
      ) {
        formFields[fieldName].value = 'No';
      }

      if (fieldName === 'productSelectionFM') {
        // eslint-disable-next-line no-param-reassign
        fields.options = formFields.productSelectionFM.options.filter(opt => {
          return !['Microsoft Licensing'].includes(opt.fields.value);
        });
        if (
          formFields &&
          formFields.productSelectionFM &&
          formFields.productSelectionFM.value &&
          formFields.productSelectionFM.value.includes('Managed IT Services')
        ) {
          // eslint-disable-next-line no-param-reassign
          fields.options = formFields.productSelectionFM.options;
        } else {
          formFields.productSelectionFM.value = [];
        }
      }

      hasProductManagedITServices =
        formFields &&
        formFields.productSelectionFM &&
        formFields.productSelectionFM.value &&
        formFields.productSelectionFM.value.includes('Managed IT Services');

      hasProductMicrosoftLicensing =
        formFields &&
        formFields.productSelectionFM &&
        formFields.productSelectionFM.value &&
        formFields.productSelectionFM.value.includes('Microsoft Licensing');

        if (fieldName === fieldRemediationPaymentPlanTerm) {
          const valueFMTerm = getFieldValue(fieldFullyManagedTerm, formFields);
          const optionsForTwelveMonths = [oneTimeTermRemediation, _12MonthTermRemediation];
          const optionsForTwentyFourMonths = [oneTimeTermRemediation, _12MonthTermRemediation, _24MonthTermRemediation];
          const optionsForThirtySixMonths = [oneTimeTermRemediation, _12MonthTermRemediation, _24MonthTermRemediation, _36MonthTermRemediation];
          if(valueFMTerm === _12MonthTermFM){
            fields.options = formFields[fieldRemediationPaymentPlanTerm].options.filter(opt => {
              return optionsForTwelveMonths.includes(opt.fields.value);
            });
          } else if(valueFMTerm === _24MonthTermFM){
            fields.options = formFields[fieldRemediationPaymentPlanTerm].options.filter(opt => {
              return optionsForTwentyFourMonths.includes(opt.fields.value);
            });
          } else if(valueFMTerm === _36MonthTermFM){
            fields.options = formFields[fieldRemediationPaymentPlanTerm].options.filter(opt => {
              return optionsForThirtySixMonths.includes(opt.fields.value);
            });
          }
        }

      if (id === formFieldsGroup) {
        const groupIsVisible = fields.fields.find(item => {
          const { fields: itemFields } = item;
          if (!formFields[itemFields.name]) return null;
          const { value, isVisible } = formFields[itemFields.name];
          return (
            (value && isVisible) ||
            isRelatedFieldExisted(
              itemFields,
              formFields,
              orderData,
              isFormTouched
            )
          );
        });

        if (typeof groupIsVisible !== 'undefined') {
          result = (
            <GroupWrapper key={key}>
              {title && <GroupTitle>{title}</GroupTitle>}
              {renderFormFields(fields.fields)}
            </GroupWrapper>
          );
        }
      } else if (id === formSectionTitle) {
        const { title: sectionTitle } = fields;
        return <Heading level="h3">{sectionTitle}</Heading>;
      } else if (id === formSection) {
        // below if condition is made not to be executed due to some rendering issues(for Annas)
        if (step === 3 && formStepName === 'Order Summaryy') {
          result = orderData && steps && (
            <OrderSummary
              stepData={steps}
              orderData={orderData}
              isFormSubmit={setIsFormSubmit}
              isQuestionVisible={isFormSubmit}
            />
          );
        } else {
          const { note } = fields;
          const renderNote = note && note.content && (
            <Note data={note} type="richText" />
          );

          const { name } = role || {};
          result = sectionIsVisible(fieldName) && (
            <ExpandCollapse.Panel
              key={key}
              id={fieldName}
              header={
                formStepBackendKey === stepKeyMain && locale !== localeFrench
                  ? `${roleLabels[name]} ${title}`
                  : `${title}`
              }
            >
              <>
                {renderNote && renderNote}
                {renderFormFields(fields.formFields)}
                {step === 3 && (
                  <OrderSummary
                    stepData={steps}
                    orderData={orderData}
                    isFormSubmit={setIsFormSubmit}
                    isQuestionVisible={isFormSubmit}
                  />
                )}
                {/* {formSummaryGroup
          ? renderFormSummary(formSummaryGroup)
          : renderFormFields(fields.formFields)} */}
              </>
            </ExpandCollapse.Panel>
          );
        }
      } else if (id === userDetailsKey) {
        const disabled = false;
        const isSameAsCheckboxChecked = false;
        result = (
          <UserDetailsForm
            key={key}
            data={fields}
            setFormFields={setFormFields}
            orderData={orderData}
            formErrors={formErrors}
            formFields={formFields}
            isEditing={isEditing}
            isFormTouched={isFormTouched}
            setIsFormTouched={setIsFormTouched}
            disabled={disabled}
            isSameAsCheckboxChecked={isSameAsCheckboxChecked}
          />
        );
      } else if (id === repeatedFormKey) {
        result = (
          <RepeatedForm
            key={key}
            data={fields}
            setFormFields={setFormFields}
            orderData={orderData}
            formErrors={formErrors}
            formFields={formFields}
            isEditing={isEditing}
            isFormTouched={isFormTouched}
            setIsFormTouched={setIsFormTouched}
          />
        );
      } else if (id === 'note') {
        const dataObj = {
          type: 'TextNote',
          note: fields.content,
          isShowNoteBackground: true
        };
        result = <FormField data={dataObj} />;
      } else {
        const fieldButtonProps = fields.type === 'Button' ? { modalForms } : {};
        let ref;
        let isDisabled;
        if (formFields[fieldName]) {
          ({ ref, isDisabled } = formFields[fieldName]);
        }

        if(fieldName === fieldRemediationOneTimeCharge || fieldName === fieldRemediationMonthlyCharge){
          isDisabled = true
        };
        const newFields = [];
        const update = false;
        // const channelName = profile.channel ? profile.channel.name : null;

        const fieldData = {
          ...fields,
          options: selectOptions || update ? newFields : fields.options,
          ...fieldButtonProps,
          note: fieldNote || fields.note,
          ref,
          formFields,
          name: fieldName,
          value: fieldValue,
          disabled: isDisabled,
          readonly: isDisabled,
          sysId,
          onChange: (e, refV) => handleFormField(e.target, refV, true),
          onBlur: () => {}
        };
        if (!isFormTouched && fields.type === 'Checkbox') {
          fieldData.checked = fieldValue;
        }

        result = (
          <FormField key={key} data={fieldData} error={error && error.text} />
        );
      }

      return result;
    });
    

  return (
    <div ref={formStepRef}>
      {!hideProgressBar && (
        <ProgressBar
          name={formStepName}
          steps={steps}
          currentStep={step}
          locale={locale}
          formName={formName}
        />
      )}
      <div></div>
      {isLoading ? (
        <ValidateLoader
          message="Please wait request is In progress...."
          isFormStep
        />
      ) : (
        <div
          style={role.name === 'SALES_SUPPORT' ? { pointerEvents: 'none' } : {}}
          onKeyDown={handleKeyDown}
        >
          <form
            name={formStepName}
            onSubmit={e => nextStep(e)}
            ref={ref => {
              setFormRef && setFormRef(ref);
              formRef.current = ref;
            }}
          >
            {sections.length && formStepName !== 'Fully Managed Form' ? (
              <Box
                style={{
                  border: '1px solid #e3e3e3',
                  boxShadow: '1px 1px 9px 4px #e3e3e3',
                  padding: '2rem',
                  marginBottom: '1rem',
                  marginLeft: '4rem',
                  marginRight: '4rem'
                }}
              >
                <div className="expand">
                  <ExpandCollapse
                    tag="h2"
                    topDivider={false}
                    open={[
                      ...open,
                      'ManagedITServicesDetails',
                      'AdditionalMonthlyServices',
                      'MicrosoftLicensing'
                    ]}
                  >
                    {renderFormFields(formStepFields)}
                    {hasProductManagedITServices && step === 1 && (
                      <ExpandCollapse.Panel
                        key="managed_it_services"
                        id="ManagedITServicesDetails"
                        header="Managed IT Services"
                      >
                        <div ref={managedItServicesErrorRef}>
                          {loading? (<p>Loading...</p>) : localSchema && localSchema.map((schemaItem, idx) => (  //use localSchema here for mapping to pass data from Be to child components
                            <SelectionsGrid
                              index={idx}
                              key={schemaItem.categoryId}
                              schema={schemaItem}
                              defaultCustomSelections={get(
                                orderData,
                                `managedItServicesData.categoryCustomSelections[${schemaItem.categoryId}]`,
                                {}
                              )}
                              defaultNumberFields={get(
                                orderData,
                                `managedItServicesData.categoryNumberSelections[${schemaItem.categoryId}]`,
                                {}
                              )}
                              defaultPriceSelections={get(
                                orderData,
                                `managedItServicesData.categoryPriceSelections[${schemaItem.categoryId}]`,
                                {}
                              )}
                              defaultSelections={get(
                                orderData,
                                `managedItServicesData.categorySelections[${schemaItem.categoryId}]`,
                                {}
                              )}
                              defaultFormattedData={get(orderData,`formattedManagedItServicesData[${schemaItem.categoryName}]`,{})}
                              extraData={managedItServicesData}
                              errors={managedItServicesErrors}
                              onChangeSelections={(
                                sectionTotals,
                                total,
                                selections,
                                customSelections,
                                numberFields,
                                priceSelections,
                                localData
                              ) => {
                                onChangeItServicesData({
                                  category: schemaItem.categoryId,
                                  sectionTotals,
                                  categoryTotal: total,
                                  selections,
                                  customSelections,
                                  numberFields,
                                  priceSelections
                                });
                                formatManagedItServicesData({
                                    category: schemaItem.categoryName,
                                    localData,
                                    idx,
                                    categoryId:schemaItem.categoryId
                                  });
                              }

                            }

                              onChangeCategoryTotals={onChangeCategoryTotals}
                            />
                          ))}
                        </div>
                        <FmProductTotal
                          defaultAdditionalFee={get(
                            orderData,
                            'managedItServicesData.fees.additionalOneTimeFee',
                            0
                          )}
                          cost={managedItServicesProductTotal[0]}
                          price={managedItServicesProductTotal[1]}
                          onFeeChange={onChangeItServicesFees}
                        />
                      </ExpandCollapse.Panel>
                    )}
                    {hasProductManagedITServices && step === 1 && (
                      <ExpandCollapse.Panel
                        key="managed_it_services"
                        id="AdditionalMonthlyServices"
                        header="Additional Monthly Services"
                        subtext={
                          <span
                            style={{ fontStyle: 'italic', fontSize: '0.8rem' }}
                          >
                            E.g., Datto monthly service fees, additional
                            onboarding costs, custom adjustments from deal
                            review
                          </span>
                        }
                      >
                        <div ref={managedItServicesErrorRef}>
                          {additionalServicesSchema.map((schemaItem, idx) => (
                            <SelectionsGrid
                              index={idx}
                              key={schemaItem.categoryId}
                              schema={schemaItem}
                              defaultCustomSelections={get(
                                orderData,
                                `managedItServicesData.categoryCustomSelections[${schemaItem.categoryId}]`,
                                {}
                              )}
                              defaultNumberFields={get(
                                orderData,
                                `managedItServicesData.categoryNumberSelections[${schemaItem.categoryId}]`,
                                {}
                              )}
                              defaultPriceSelections={get(
                                orderData,
                                `managedItServicesData.categoryPriceSelections[${schemaItem.categoryId}]`,
                                {}
                              )}
                              defaultSelections={get(
                                orderData,
                                `managedItServicesData.categorySelections[${schemaItem.categoryId}]`,
                                {}
                              )}
                              extraData={additionalServicesData}
                              errors={managedItServicesErrors}
                              onChangeCategoryTotals={onChangeCategoryTotals}
                              onChangeSelections={(
                                sectionTotals,
                                total,
                                selections,
                                customSelections,
                                numberFields,
                                priceSelections
                              ) => {
                                onChangeAdditionalServicesData({
                                  category: schemaItem.categoryId,
                                  sectionTotals,
                                  categoryTotal: total,
                                  selections,
                                  customSelections,
                                  numberFields,
                                  priceSelections
                                });
                              }}
                            />
                          ))}
                        </div>
                      </ExpandCollapse.Panel>
                    )}
                    {hasProductMicrosoftLicensing && step === 1 && (
                      <ExpandCollapse.Panel
                        key="microsoft_licensing"
                        id="MicrosoftLicensing"
                        header="Microsoft Licensing"
                      >
                        <FmMicrosoftLicensing
                          defaultValues={get(
                            orderData,
                            'microsoftLicensingData',
                            {}
                          )}
                          orderData={orderData}
                          onChange={onChangeMicrosoftLicensingData}
                        />
                        {/* {microsoftLicensingData.adjustedTotalPrice > 0 && (
                        <FmMicrosoftLicensingTotal
                        price={microsoftLicensingData.adjustedTotalPrice}
                        />
                        )} */}
                      </ExpandCollapse.Panel>
                    )}
                  </ExpandCollapse>
                  {(hasProductManagedITServices ||
                    hasProductMicrosoftLicensing) &&
                    step === 1 && (
                      <div
                        style={{
                          padding: '2rem'
                        }}
                        ref={discountErrorRef}
                      >
                        <DiscountApprovalSection
                          appliedDiscountId={appliedDiscountId}
                          orderId={orderData.id}
                          term={getFieldValue(fieldFullyManagedTerm, formFields)}
                          discounts={discountsData}
                          onDiscountAdded={(id)=>{
                            getAddedDiscounts(orderData.id, id);
                            setShowDownloadQuoteFooter(false);
                          }}
                          onDiscountUpdated={()=>{
                            getAddedDiscounts(orderData.id);
                            setShowDownloadQuoteFooter(false);
                          }}
                          onDiscountError={()=>console.log('Error adding discount')}
                          managedITServicesMonthly={getManagedItServicesTotal('monthly') +
                          getAdditionalServicesTotal('monthly')}
                          onApplyDiscount={(id, action) => onApplyDiscount(id, action)}
                          discountError={discountError}
                          discountWarnings={getDiscountWarnings(
                            appliedDiscountId,
                            getFieldValue(fieldFullyManagedTerm, formFields) === _12MonthTermFM,
                            getManagedItServicesTotal('monthly') + getAdditionalServicesTotal('monthly'),
                            getFieldValue(creditCheckNumberField, formFields) && getFieldValue(fieldTechnicalReviewNumber, formFields)
                          )}
                          managedItServicesTotal={getManagedItServicesTotal('monthly')}
                          onboardingFee={getManagedItServicesTotal('oneTime')}
                        />
                      </div>
                    )}
                </div>
              </Box>
            ) : (
              <div style={{ width: '100%' }}>
                {formStepFields ? (
                  renderFormFields(formStepFields)
                ) : (
                  <>
                    <h3 style={{ marginBottom: '1em' }}>{summaryLabel}</h3>
                    {/* {getSummary()} */}
                  </>
                )}
              </div>
            )}
          </form>
        </div>
      )}
      {formName === 'Fully_Managed_Form' && role.name !== 'SALES_SUPPORT' && (
        <FmStatusBar
          step={step}
          isLastStep={steps.length === step}
          isFormTouched={isFormTouched}
          isFormSubmit={isFormSubmit}
          onBackClick={prevStep}
          onProceedClick={nextStep}
          onSaveAndExit={saveAndExit}
          showDownloadQuoteFooter={showDownloadQuoteFooter}
          totalMonthly={
            getManagedItServicesTotal('monthly') +
            getAdditionalServicesTotal('monthly') +
            getMicrosoftLicensingTotal() -
            (getAppliedDiscountItem.overrideMonthly || getAppliedDiscountItem.approvedMonthly || getAppliedDiscountItem.monthly || 0)
          }
          isDiscountApplied={!!appliedDiscountId}
          totalOneTime={getManagedItServicesTotal('oneTime') - 
            (getAppliedDiscountItem.overrideOnetime || getAppliedDiscountItem.approvedOnetime || getAppliedDiscountItem.onetime || 0)
          }
          onQuoteDownload={() =>
            window.open(
              `${apiHost}/orders/${orderData.id}/fully-managed-proposal-pdf?lang=${locale}`,
              '_blank'
            )
          }
        />
      )}
      {formName === 'Fully_Managed_Form' && role.name === 'SALES_SUPPORT' && (
        <>
          <FmSaleSupportStatusBar
            step={step}
            isLastStep={steps.length === step}
            onBackClick={prevStep}
            onProceedClick={nextStepSaleSupport}
          />
        </>
      )}
      <Modal
        heading={getAppliedDiscountItem.status === 'Rejected' ? 'Discount Rejected' : 'Discount Pending Approval'}
        bodyText={discountErrorPopupText}
        confirmCTAText="Save and Continue later"
        onConfirm={() => onSaveAndCloseDiscountPopup(true)}
        onClose={() => onSaveAndCloseDiscountPopup()}
        isOpen={!!discountErrorPopupText}
      />
    </div>
  );
};

FormStepFM.propTypes = {
  stepData: PropTypes.shape({
    fields: PropTypes.shape({
      name: PropTypes.string,
      image: PropTypes.string,
      formStepFields: PropTypes.arrayOf(PropTypes.shape({})),
      showTotal: PropTypes.bool,
      modalForms: PropTypes.arrayOf(PropTypes.shape({})),
      backendKey: PropTypes.string
    })
  }),
  steps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  step: PropTypes.number.isRequired,
  updateStep: PropTypes.func,
  setFormRef: PropTypes.func,
  onFormSubmit: PropTypes.func,
  onSaveAndExit: PropTypes.func,
  orderData: PropTypes.shape({
    id: PropTypes.number,
    productSelectionFM: PropTypes.arrayOf(PropTypes.string),
    managedItServicesData: PropTypes.shape({}),
    microsoftLicensingData: PropTypes.shape({
      adjustedTotalPrice: PropTypes.number
    }),
    managedItServicesSummary: PropTypes.shape({
      totalMonthlyCharges: PropTypes.number,
      totalOneTimeCharges: PropTypes.number
    })
  }),
  setOrderData: PropTypes.func.isRequired,
  hideProgressBar: PropTypes.bool,
  isEditing: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

FormStepFM.defaultProps = {
  stepData: null,
  updateStep: () => {},
  setFormRef: null,
  onFormSubmit: null,
  orderData: {},
  onSaveAndExit: () => {},
  hideProgressBar: false
};

export default FormStepFM;
